import getEditorData from '../../Common/getEditorData';
import saveEditorData from '../../Common/saveEditorData';
import router from '../../../router/routes';
import destroyEditorData from '../../Common/destroyEditorData';

export default {
    namespaced: true,

    state: {
        pageId: 0,
        name: '',
        slug: '',
        order: 0,
        postData: [],
        published: false,
        route: '',
        subtitle: '',
        deleteModal: false,
        cards: [],
        level: 'basic'
    },

    getters: {
        postData(state) {
            return {
                name: state.name,
                slug: state.slug,
                subtitle: state.subtitle,
                order: state.order,
                published: state.published,
                level: state.level,
            };
        },

        publishedText(state) {
            if (state.published) {
                return 'Published';
            } else {
                return 'Not Published';
            }
        },

        route(state) {
            if (state.pageId > 0) {
                return '/api/page/edit/' + state.pageId;
            } else {
                return '/api/page/create';
            }
        }
    },

    mutations: {
        setPageId(state, value) {
            state.pageId = value;
        },

        setSlug(state, value) {
            state.slug = value;
        },

        setLevel(state, value) {
            state.level = value;
        },

        setName(state, value) {
            state.name = value;
        },

        setOrder(state, value) {
            state.order = value;
        },

        setPublished(state, value) {
            state.published = value;
        },

        setSubtitle(state, value) {
            state.subtitle = value;
        },

        toggleDeleteModal(state, value) {
            state.deleteModal = value;
        },

        setCards(state, value) {
            state.cards = value;
        }
    },

    actions: {
        getData({ commit, getters, state }) {
            commit('overlay/toggle', true, { root: true });
            commit('setPageId', router.currentRoute.params.id ? router.currentRoute.params.id : 0);

            getEditorData(getters.route).then((response) => {
                const page = response.data.data.page;
                if (state.pageId > 0) {
                    commit('setName', page.name);
                    commit('setSlug', page.slug);
                    commit('setOrder', page.order);
                    commit('setPublished', page.published);
                    commit('setSubtitle', page.subtitle);
                    commit('setCards', page.cards);
                    commit('setLevel', page.level);
                } else {
                    // Make sure we don't return previous creation data.
                    // If you remove this, and someone who has previously created a card
                    // returns to the creation form, the previous card's data will still be there.
                    commit('setName', '');
                    commit('setSlug', '');
                    commit('setOrder', 0);
                    commit('setPublished', 0);
                    commit('setSubtitle', '');
                    commit('setCards', []);
                    commit('setLevel', 'basic');
                }

                commit('overlay/toggle', false, { root: true });
            });
        },

        saveData({ getters, commit, dispatch }) {
            saveEditorData('page', getters.route, getters.postData)
                .then((pageId) => {
                    if (router.currentRoute.name === 'PageEdit') {
                        dispatch('sidebar/getSidebar', '', { root: true })
                            .then(() => {
                                commit('overlay/toggle', false, { root: true });
                            });
                    } else {
                        router.push('/page/edit/' + pageId);
                    }
                })
                .catch(() => {});
        },

        destroyData({ state }) {
            destroyEditorData('/api/page/delete/' + state.pageId)
                .then(() => {})
                .catch(() => {});
        },
    },
};
